import { appRoutes } from 'features/app/routes/paths';

export const dashboardPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/dashboard`,
    sendSingleGift: `${appRoutes.static.root}/dashboard/send-single-gift`,
    sendGiftInBulk: `${appRoutes.static.root}/dashboard/send-gift-in-bulk`,
  },
});
